import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.autoHide = setInterval(() => {
      this.close()
    }, 5000);
  }

  disconnect() {
    clearInterval(this.autoHide);
  }

  close() {
    this.element.remove()
  }
}
